



export class VoucherContext {

    public voucherCode: string = ""
    public bookingId: string = ""
    constructor() {

    }
}